import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

import { useManagePaymentMethods } from "./ManagePaymentMethodsContext";
import PaymentMethod from "./PaymentMethod/PaymentMethod";

PaymentMethodsList.propTypes = {
  showQuickControls: PropTypes.bool,
  hasMobilePhone: PropTypes.bool,
  onCardSelect: PropTypes.func,
  show: PropTypes.bool,
  networkName: PropTypes.string,
};

export default function PaymentMethodsList({
  showQuickControls,
  hasMobilePhone,
  onCardSelect,
  updateExternalPaymentMethods,
  show = true,
  networkName,
}) {
  const { paymentMethods } = useManagePaymentMethods().state;

  const [shouldShow, setShouldShow] = useState(show);

  let showTimer;

  useEffect(() => {
    if (show) {
      clearTimeout(showTimer);
      setShouldShow(true);
    } else if (!show) {
      showTimer = setTimeout(() => setShouldShow(false), 250);
      return () => clearTimeout(showTimer);
    }
  }, [show]);

  const animationProperties = {
    layout: true,
    initial: "hidden",
    animate: shouldShow ? "show" : "hidden",
    variants: {
      show: {
        transition: {
          staggerChildren: 0.1,
          delayChildren: 0.2,
        },
      },
    },
  };
  return (
    <Wrapper {...animationProperties}>
      <AnimatePresence>
        {paymentMethods.map((data, i, allPaymentMethods) => (
          <PaymentMethod
            key={data.ID}
            showQuickControls={showQuickControls}
            hasMobilePhone={hasMobilePhone}
            allPaymentMethods={allPaymentMethods}
            updateExternalPaymentMethods={updateExternalPaymentMethods}
            onCardSelect={onCardSelect}
            networkName={networkName}
            {...data}
          />
        ))}
      </AnimatePresence>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)``;
